import MainCatalogsEditorBase from '../MainCatalogsEditorBase';
import { compose, mdsWidget, mdsLazyProto } from 'dojo/_base/declare';
import template from './BookingStatusEditor.html?raw';
import Edit from '../../../moreCore/UI/Edit/Edit';
import CheckBox from '../../../moreCore/UI/CheckBox/CheckBox';
import NumberInput from '../../../moreCore/UI/NumberInput/NumberInput';
import { MainCatalogTypes, MainCatalogs_Classes } from "../../_loadingHelpers/MainCatalogTypes";
import MultiLangEdit from '../../../moreCore/UI/MultiLangEdit/MultiLangEdit';

class BookingStatusEditor extends compose(MainCatalogsEditorBase) {
    templateString: any = template;

    bs_Input_Code: MdsLax<InstanceType<typeof Edit>>;
    //bs_Input_Description: Edit = new Edit();
    bs_Input_Description_MultiLang: MdsLax<InstanceType<typeof MultiLangEdit<MainCatalogTypes.BookingStatus_LoadData>>>;
    bs_Input_TextColor: HTMLInputElement;
    bs_Input_BackgroundColor: HTMLInputElement;
    bs_Input_Order: MdsLax<InstanceType<typeof NumberInput>>;

    bs_Checkbox_Active: MdsLax<InstanceType<typeof CheckBox>>;
    bs_Checkbox_Definitive: MdsLax<InstanceType<typeof CheckBox>>;
    bs_Checkbox_Cancelled: MdsLax<InstanceType<typeof CheckBox>>;
    bs_Checkbox_Option: MdsLax<InstanceType<typeof CheckBox>>;
    bs_Checkbox_SchedulerDefinitive: MdsLax<InstanceType<typeof CheckBox>>;
    bs_Checkbox_GeneratingAutoCostUnit: MdsLax<InstanceType<typeof CheckBox>>;
    bs_Checkbox_ImportToCommdoc: MdsLax<InstanceType<typeof CheckBox>>;
    bs_Checkbox_Repository: MdsLax<InstanceType<typeof CheckBox>>;
    bs_Checkbox_NotRelevantForOverlappingBookings: MdsLax<InstanceType<typeof CheckBox>>;

    formData: MainCatalogTypes.BookingStatus_SaveData = {
        ID: "",
        is_new_status: null,
        code: "",
        description: "",
        is_active: true,
        is_definitive: null,
        is_cancelled: null,
        is_option: null,
        is_scheduler_definitive: null,
        is_generating_auto_cost_unit: null,
        is_import_to_commdoc: null,
        is_repository: null,
        is_not_relevant_for_overlapping_bookings: null,
        order: null,
        coloration: null,
        __multilang: {}
    };

    prepareFormData(data?: MainCatalogTypes.BookingStatus_LoadData): void {

        if (data) {

            this.bs_Input_Code.setValue(data.code, true);
            this.bs_Input_Description_MultiLang.setValue({ entity: data, targetAttribute: "description" }, true);
            //this.bs_Input_Description.setValue(data.description_D, true);
            this.bs_Input_TextColor.value = data.coloration.TextColor.Hex;
            this.bs_Input_BackgroundColor.value = data.coloration.BackColor.Hex;
            this.bs_Input_Order.setValue(data.order, true);

            this.bs_Checkbox_Active.setValue(data.is_active, true);
            this.bs_Checkbox_Definitive.setValue(data.is_definitive, true);
            this.bs_Checkbox_Cancelled.setValue(data.is_cancelled, true);
            this.bs_Checkbox_Option.setValue(data.is_option, true);
            this.bs_Checkbox_SchedulerDefinitive.setValue(data.is_scheduler_definitive, true);
            this.bs_Checkbox_GeneratingAutoCostUnit.setValue(data.is_generating_auto_cost_unit, true);
            this.bs_Checkbox_ImportToCommdoc.setValue(data.is_import_to_commdoc, true);
            this.bs_Checkbox_Repository.setValue(data.is_repository, true);
            this.bs_Checkbox_NotRelevantForOverlappingBookings.setValue(data.is_not_relevant_for_overlapping_bookings, true);

            this.formData.ID = data.ID;
            this.formData.is_new_status = false;
        } else {

            this.bs_Input_Code.setValue("", true);
            //this.bs_Input_Description.setValue("", true);
            this.bs_Input_Description_MultiLang.setValue({ entity: null, targetAttribute: "description" });
            this.bs_Input_BackgroundColor.value = "#ffffff";
            this.bs_Input_TextColor.value = "#000000";
            this.bs_Input_Order.setValue(null, true);

            this.bs_Checkbox_Active.setValue(true, true);
            this.bs_Checkbox_Definitive.setValue(false, true);
            this.bs_Checkbox_Cancelled.setValue(false, true);
            this.bs_Checkbox_Option.setValue(false, true);
            this.bs_Checkbox_SchedulerDefinitive.setValue(false, true);
            this.bs_Checkbox_GeneratingAutoCostUnit.setValue(false, true);
            this.bs_Checkbox_ImportToCommdoc.setValue(false, true);
            this.bs_Checkbox_Repository.setValue(false, true);
            this.bs_Checkbox_NotRelevantForOverlappingBookings.setValue(false, true);

            this.formData.ID = "";
            this.formData.is_new_status = true;
        }

        this.serializeFormData();
        this.originalData = JSON.stringify(this.formData);
        console.debug("ORIGINAL", this.originalData);
        this.StandbyStop();

        this.checkDirty();
    }

    serializeFormData(): void {

        this.formData.code = this.bs_Input_Code.getValue();
        //this.formData.description = this.bs_Input_Description.getValue();
        //this.formData.__multilang["description"] = this.bs_Input_Description_MultiLang.getValue();
        this.bs_Input_Description_MultiLang.getValueOntoEntity(this.formData as any);
        this.formData.is_active = this.bs_Checkbox_Active.getValue();
        this.formData.is_definitive = this.bs_Checkbox_Definitive.getValue();
        this.formData.is_cancelled = this.bs_Checkbox_Cancelled.getValue();
        this.formData.is_option = this.bs_Checkbox_Option.getValue();
        this.formData.is_scheduler_definitive = this.bs_Checkbox_SchedulerDefinitive.getValue();
        this.formData.is_generating_auto_cost_unit = this.bs_Checkbox_GeneratingAutoCostUnit.getValue();
        this.formData.is_import_to_commdoc = this.bs_Checkbox_ImportToCommdoc.getValue();
        this.formData.is_repository = this.bs_Checkbox_Repository.getValue();
        this.formData.is_not_relevant_for_overlapping_bookings = this.bs_Checkbox_NotRelevantForOverlappingBookings.getValue();


        this.formData.order = this.bs_Input_Order.getValue();

        let coloration: MainCatalogTypes.PIT_Coloration = {
            TextColor: null,
            BackColor: null
        };
        let textColor: MainCatalogTypes.PIT_Color = {
            Hex: "",
            Red: 0,
            Green: 0,
            Blue: 0
        };
        let backColor: MainCatalogTypes.PIT_Color = {
            Hex: "",
            Red: 0,
            Green: 0,
            Blue: 0
        };
        let textHex = this.bs_Input_TextColor.value;
        let backHex = this.bs_Input_BackgroundColor.value;

        textColor.Hex = textHex;
        textColor.Red = parseInt(textHex.slice(1, 3), 16);
        textColor.Green = parseInt(textHex.slice(3, 5), 16);
        textColor.Blue = parseInt(textHex.slice(5, 7), 16);

        backColor.Hex = backHex;
        backColor.Red = parseInt(backHex.slice(1, 3), 16);
        backColor.Green = parseInt(backHex.slice(3, 5), 16);
        backColor.Blue = parseInt(backHex.slice(5, 7), 16);

        coloration.TextColor = textColor;
        coloration.BackColor = backColor;

        this.formData.coloration = coloration;

        console.debug("SERIALIZED DATA", this.formData);
    }

    isValid(): boolean {

        let b: boolean = true;

        if (!this.formData.code) b = false;

        //if (!this.formData.description) b = false;

        return b;
    }


    //BASE
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.entityClass = MainCatalogs_Classes.EvBookingStatus;

        this.bs_Input_Code.setMaxLength(20);
        //this.bs_Input_Description.setMaxLength(255);
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

mdsLazyProto(BookingStatusEditor.prototype, {
  bs_Input_Code: () => (new Edit()),
  bs_Input_Order: () => (new NumberInput()),
  bs_Checkbox_Active: () => (new CheckBox()),
  bs_Checkbox_Definitive: () => (new CheckBox()),
  bs_Checkbox_Cancelled: () => (new CheckBox()),
  bs_Checkbox_Option: () => (new CheckBox()),
  bs_Checkbox_SchedulerDefinitive: () => (new CheckBox()),
  bs_Checkbox_GeneratingAutoCostUnit: () => (new CheckBox()),
  bs_Checkbox_ImportToCommdoc: () => (new CheckBox()),
  bs_Checkbox_Repository: () => (new CheckBox()),
  bs_Checkbox_NotRelevantForOverlappingBookings: () => (new CheckBox()),
});
export default mdsWidget(BookingStatusEditor);
